import React from 'react';
// import logo from './logo.svg';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Invoice from './components/Invoice';
import Login from './components/Login';
import { UserProvider } from './contexts/UserInfoContext';

function App() {
    return (
        <UserProvider>
            <div className="App">
                <Routes>
                    <Route path="/invoice" element={<Invoice />} />
                    <Route path="/" element={<Login />} />
                </Routes>
            </div>
        </UserProvider>
    );
}

export default App;
